import { getPgaCoachJourneySearchInitialProps } from './get-search-initial-props'
import { buildLegacyProgramsSearchRedirectLocation } from './things-to-do-search-redirect'

export async function getPgaCoachProgramsPageInitialProps(ctx) {
  if (ctx.req?.url) {
    const [pathname, search = ''] = ctx.req.url.split('?')
    const legacyLocation = buildLegacyProgramsSearchRedirectLocation({
      pathname,
      search: search ? `?${search}` : '',
    })
    if (legacyLocation && ctx.res) {
      ctx.res.writeHead(302, { Location: legacyLocation })
      ctx.res.end()
      return {
        redirected: true,
        location: legacyLocation,
      }
    }
  }

  return getPgaCoachJourneySearchInitialProps(ctx)
}
